module.exports = __webpack_public_path__ + "img/yhhd.45e6bf3d.png";